import { FlexRow } from '@gorila-shared-ui/components';
import { HeaderNavigation } from 'baseui/header-navigation';
import { useStyles } from '../../../hooks/useStyles';
import { PageTitle } from './PageTitle';
import { UserMenu } from './UserMenu';

export function Navbar() {
  const { theme, css } = useStyles();

  return (
    <HeaderNavigation
      overrides={{
        Root: {
          style: {
            paddingTop: theme.sizing.scale500,
            paddingRight: theme.sizing.scale500,
            paddingBottom: theme.sizing.scale500,
            paddingLeft: theme.sizing.scale500,
            columnGap: theme.sizing.scale500,
            alignItems: 'center',
            minHeight: '60px',
            boxSizing: 'border-box',
          },
        },
      }}
    >
      <FlexRow classNames={css({ flex: 1 })}>
        <PageTitle />
      </FlexRow>
      <UserMenu />
    </HeaderNavigation>
  );
}
